import { Button } from "antd";
import { ROUTES } from "Features/Routes/routeConstants";
import { ArrowRight, Gift, Sparkles } from "lucide-react";
import { useNavigate } from "react-router-dom";

export const PremiumBanner = () => {
  const navigate = useNavigate();
  return (
    <div className="relative overflow-hidden bg-gradient-to-r from-yellow-50 via-orange-50 to-yellow-50 border-2 border-yellow-300 rounded-2xl p-6 shadow-lg w-[75%] m-2">
      {/* Sparkle decorations */}
      <Sparkles className="absolute top-2 right-2 w-6 h-6 text-yellow-400 animate-pulse" />
      <Sparkles
        className="absolute bottom-2 left-2 w-5 h-5 text-orange-400 animate-pulse"
        style={{ animationDelay: "0.5s" }}
      />

      <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-center sm:text-left">
        <div className="flex-shrink-0">
          <div className="w-12 h-12 bg-yellow-200 rounded-full flex items-center justify-center">
            <Gift className="w-6 h-6 text-yellow-700" />
          </div>
        </div>

        <div className="flex-1">
          <h3 className="text-lg font-bold text-gray-900 mb-1">
            🎉 Get Premium FREE with Your Education Loan
          </h3>
          <p className="text-base text-gray-700">
            Get no-collateral student loans at low interest rates through
            OneGrad partners and receive{" "}
            <span className="font-semibold text-orange-700">
              100% Premium membership fee refund
            </span>
          </p>
        </div>

        <Button
          className="h-fit hover:scale-105 !border-none flex-shrink-0 bg-gradient-to-r from-yellow-400 to-orange-400 hover:!text-black hover:!bg-gradient-to-r hover:!from-yellow-500 hover:!to-orange-500 text-black font-bold px-6 py-3 rounded-xl transition-all duration-200 shadow-md hover:!shadow-lg"
          onClick={() => {
            navigate(ROUTES.PRICING);
          }}
        >
          Learn More
          <ArrowRight className="w-4 h-4 ml-2 inline" />
        </Button>
      </div>
    </div>
  );
};
